import SCHEME from '../api/publicScheme';
import { Province_2sc, City_2sc } from '../data/area';
import appbridge from '../util/appbridge';

//根据pid获取pname
function getPnameFromPid(pid) {
  let pname = ''
  if (pid === '' || pid === '0') {
    pname = '全国';
  }
  Province_2sc.map((item) => {
    item.V.map((item2 => {
      if (item2.V === pid + '') {
        pname = item2.T;
      }
    }))
  });
  return pname;
};

//根据市id获取城市名称
function getCnameFromCid(cid) {
  let cname = '';
  if (!cid) {
    cname = '';
  } else {
    let cityInfo = City_2sc.filter((item => {
      if (item.V === cid + '') {
        return item.T;
      }
    }));
    if (cityInfo.length > 0) {
      cname = cityInfo[0].T.split(' ')[1];
    }
  }

  return cname;
}

function domAppendJs(src, callback, id) {
  //判断是否已存在js
  if (id && document.getElementById(id)) {
    callback && callback();
    return;
  }
  // dom注入登录js
  var script = document.createElement('script'),
    head = document.getElementsByTagName('head')[0];
  script.type = 'text/javascript';
  script.charset = 'UTF-8';
  script.src = src;

  if (id) {
    script.id = id
  }
  if (script.addEventListener) {
    script.addEventListener('load', function () {
      callback && callback();
    }, false);
  } else if (script.attachEvent) {
    script.attachEvent('onreadystatechange', function () {
      var target = window.event.srcElement;
      if (target.readyState == 'loaded') {
        callback && callback();
      }
    });
  }
  head.appendChild(script);
}

function domAppendCss(filename) {
  var fileref = document.createElement("link")
  fileref.setAttribute("rel", "stylesheet")
  fileref.setAttribute("type", "text/css")
  fileref.setAttribute("href", filename)
  if (typeof fileref != "undefined") {
    document.getElementsByTagName("head")[0].appendChild(fileref)
  }
}


const UA = navigator.userAgent.toLocaleLowerCase();

//是否在车智赢app中
function isATCApp() {
  return UA.indexOf('autotradercloud') > -1;
}
//是否是二手车app
function isEscApp() {

  return UA.indexOf('che_android') > -1 || UA.indexOf('che_ios') > -1;
}
//是否是主软 app
function isManApp() {
  return UA.indexOf('auto_android') > -1 || UA.indexOf('auto_iphone') > -1
}
//微信中打开
function isWechat() {
  return UA.indexOf('micromessenger') > -1
}
//验证手机号码
function checkMobile(mobile) {
  var regPhone = new RegExp("^1[3,4,5,6,7,8,9]{1}[0-9]{9}$", "ig");
  return (mobile && mobile.length === 11 && regPhone.test(mobile));
}

//车源列表页面跳转
//brandid-品牌id, brandname-品牌名称, seriesid-车系id, sname-车系名称, pid-省份id, cid-城市id, pvid-PV, url-链接, ispc-是否pc（0/1）, infoids = ''//车型id, isoutsite, sourceid：1：个人，2：商家，3：认证商家，20：平台车, priceregion = ''-价格区间,agerange=''车龄区间,mileage=''里程区间,
//infoids必须是字符串，如果是多个以 ,号分开 isoutsite=81800 是818车源,sourceid 4s点直卖、
function openListUlr(brandid, brandname, seriesid, sname, pid, cid, pvid, url, ispc, infoids = '', isoutsite, sourceid, priceregion = '', agerange = '', mileage = '', fromtype = '') {
  let jumpUrl = '';
  if (isEscApp()) {
    let para = {
      "title": "列表页",
      "pid": pid + "",
      "cid": cid + "",
      "brandid": brandid + "",
      "seriesid": seriesid + "",
      "pvareaid": pvid + "",
    }
    if (+isoutsite > 0) {
      para.isoutsite = `${isoutsite}`;
    }
    if (+sourceid > 0) {
      para.sourceid = `${sourceid}`;
    }
    if (`${infoids}`.length > 0) {
      para.infoid = `${infoids}`;
    }
    if (priceregion.length > 0) {
      para.priceregion = priceregion;
    }
    //添加车龄传参
    if (agerange.toString().length > 0) {
      para.registeageregion = agerange;
    }
    //添加里程传参
    if (mileage.toString().length > 0) {
      para.mileageregion = mileage;
    }
    if (+fromtype > 0) {
      para.fromtype = `${fromtype}`;
    }
    jumpUrl = `${SCHEME.USEDCAR}/rnhomegobuycar?param=${encodeURIComponent(JSON.stringify(para))}`;
    console.log(jumpUrl + '--' + JSON.stringify(para));
    // return;
  } else if (isManApp()) {
    if (brandid > 0) {
      var params = [];
      params.push(`pvareaid=${pvid}`)
      var brand = { "brandid": brandid + "", "bname": brandname }
      if (+seriesid > 0) {
        brand.seriesid = seriesid;
        brand.sname = sname;
      }
      params.push(`brand=${encodeURIComponent(JSON.stringify(brand))}`)
      if (+isoutsite > 0) {
        params.push(`service=${isoutsite}`)
      }
      if (+sourceid > 0) {
        params.push(`sourceid=${sourceid}`)
      }
      jumpUrl = `${SCHEME.AUTOHOME_USEDCAR}/buycarlist?${params.join("&")}`
    } else {
      if (+isoutsite > 0) {
        jumpUrl = `${SCHEME.AUTOHOME_USEDCAR}/buycarlist?service=${isoutsite}&pvareaid=${pvid}`;
      } else {
        jumpUrl = `${SCHEME.AUTOHOME_USEDCAR}/buycarlist?pvareaid=${pvid}`;
      }
    }
    if (priceregion.length > 0) {
      jumpUrl = jumpUrl + `&price=${priceregion}`;
    }
    //添加车龄传参
    if (agerange.toString().length > 0) {
      jumpUrl += `&agerange=${agerange}`
    }
    //添加里程传参
    if (mileage.toString().length > 0) {
      jumpUrl += `&mileage=${mileage}`
    }
    //添加商家类型：1：个人，2：商家，3：认证商家，20：平台车
    if (+sourceid > 0) {
      jumpUrl += `&sourceid=${sourceid}`
    }
    //添加inoif传参
    let topids = '';
    if (infoids.toString().length > 0) {
      topids = `&topids=${infoids}`;
    }
    //主软里不用传cid参数，跳转之前需要从新设置主软件cid
    jumpUrl += `${topids}`;
    console.log(jumpUrl);
    // return;
  } else {
    jumpUrl = url;
  }
  console.log('jumpURL - ', jumpUrl);
  // return;
  if (ispc == 1) {
    window.open(jumpUrl);
  } else {
    location.href = jumpUrl;
  }
}

//获取打开列表页的价格筛选条件
function getPriceRegion(minPrice, maxPrice) {
  // m&pc 0_5 50_0
  let priceRegion = `${minPrice}_${maxPrice}`
  //二手车app 0-5 50-65535
  if (isEscApp()) {
    priceRegion = `${minPrice}-${maxPrice}`;
    if (maxPrice === 0) {
      priceRegion = `${minPrice}-65535`
    }
  }
  //内嵌app 0-5 5-9999
  if (isManApp()) {
    priceRegion = `${minPrice}-${maxPrice}`;
    if (maxPrice === 0)
      priceRegion = `${minPrice}-9999`;
  }
  return priceRegion;
}

//获取 URL 参数
function getUrlParams() {
  var search = location.search; //获取url中"?"符后的字串
  var querys = {};
  if (search.indexOf("?") != -1) {
    var params = search.substr(1).split("&");
    for (var i = 0; i < params.length; i++) {
      var pair = params[i].split("=");
      if (pair.length <= 1) continue;
      querys[pair[0]] = pair[1];
    }
  }
  return querys;
}
//转场公共方法
function transformToUrl(url) {
  const EscApp = isEscApp();
  const ManApp = isManApp();
  /* if (ManApp == 1) {//主软
    const target = 'autohome://insidebrowserwk?url=' + encodeURIComponent(url);
    //alert(target)
    window.location.href = target;
  }
  else if (EscApp == 1) {//2scapp
    const target = 'usedcar://scheme.che168.com/web?param=' + encodeURIComponent(JSON.stringify({ url: url + '&uccarstate=usenewwebview' }));
    //alert(target)
    window.location.href = target;
  }
  else {//m
    window.location.href = url;
  } */
  window.location.href = url;
}
//cid转pid
function cid2pid(cid) {
  return parseInt(+cid / 10000) * 10000;
}

//给数组排重
function uniqueArr(arr) {
  return arr.filter(function (item, index, arr) {
    //当前元素，在原始数组中的第一个索引==当前索引值，否则返回当前元素
    return arr.indexOf(item, 0) === index;
  });
}

//时间差 毫秒@date1 当前日期对象  @date2日期对象
function timeDiff(date1, date2) {
  console.log(date1.getTime(), date2.getTime())
  return Math.floor((date2.getTime() - date1.getTime()));
}

//获取经纬度
function getGeolocation() {
  let result = { message: '', returncode: 0, res: { lon: 0, lat: 0 } };
  return new Promise((resolve, reject) => {
    if (isManApp()) {
      //主软
      AHAPP.invokeNative("realtimelocation", {
        success: function (res) {
          result.res.lat = res.result.BDLatitude;
          result.res.lon = res.result.BDLongitude;
          // log(JSON.stringify(res)); // 打印客户端返回的参数内容
          resolve(result);
        },
        fail: function (res) {
          // log(JSON.stringify(res));
          result.returncode = 100;
          result.message = JSON.stringify(res);
          reject(result);
        },
      });
    } else if (isEscApp()) {
      //二手车
      appbridge.invoke('intentGeo', {}, (res) => {
        if (res) {
          result.res.lat = res.latitude;
          result.res.lon = res.longitude;
          resolve(result);
        } else {
          resolve('');
        }
      })
    } else {
      //H5
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          result.res.lat = position.coords.latitude;
          result.res.lon = position.coords.longitude;
          resolve(result);
        }, (error) => {
          console.log(error);
          let message = '';
          switch (error.code) {
            case error.PERMISSION_DENIED:
              message = "您拒绝对获取地理位置的请求";
              break;
            case error.POSITION_UNAVAILABLE:
              message = "位置信息是不可用的";
              break;
            case error.TIMEOUT:
              message = "请求您的地理位置超时";
              break;
            case error.UNKNOWN_ERROR:
              message = "未知错误";
              break;
          }
          result.returncode = 20;
          result.message = message;
          reject(result);
        });
      } else {
        result.returncode = 100;
        result.message = "您的浏览器不支持使用HTML 5来获取地理位置服务";
      }
    }
  });
}

//获取重复字符串
function repeatStringNumTimes(str, num) {
  let repeatStr = '';
  for (let i = 0; i < num; i++) {
    repeatStr += str;
  }
  return repeatStr;
}

function getBrowser() {
  const ua = navigator.userAgent;
  return {
    trident: ua.indexOf("Trident") > -1, // IE内核
    presto: ua.indexOf("Presto") > -1, // opera内核
    webKit: ua.indexOf("AppleWebKit") > -1, // 苹果、谷歌内核
    gecko: ua.indexOf("Gecko") > -1 && ua.indexOf("KHTML") === -1, // 火狐内核
    mobile: !!ua.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
    ios: !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
    android: ua.indexOf("Android") > -1 || ua.indexOf("Adr") > -1, // android终端
    iPhone: ua.indexOf("iPhone") > -1, // 是否为iPhone或者QQHD浏览器
    iPad: ua.indexOf("iPad") > -1, // 是否iPad
    webApp: ua.indexOf("Safari") === -1, // 是否web应该程序，没有头部与底部
    weixin: ua.indexOf("MicroMessenger") > -1, // 是否微信 （2015-01-22新增）
    qq: ua.match(/\sQQ/i) === " qq", // 是否QQ
    escApp: ua.indexOf("UsedCar") > -1, // 二手车APP
    autohome: ua.indexOf("autohomeapp") > -1 // 主软
  };
}

function getAPPID() {
  const os = getBrowser();
  let _appid = 'pc';
  if (os.mobile) {
    switch (true) {
      case os.escApp && os.iPhone:
        _appid = '2scapp.ios';
        break;
      case os.escApp && os.android:
        _appid = '2scapp.android';
        break;
      case os.autohome && os.iPhone:
        _appid = 'main2sc.ios';
        break;
      case os.autohome && os.android:
        _appid = 'main2sc.android';
        break;
      default:
        _appid = '2sc.m';
    }
  }
  return _appid;
}
//获取维一id
function getUniqueid() {
  return new Promise((resolve, reject) => {
    if (isEscApp()) {
      appbridge.invoke('invokePublicParam', {}, (data) => {
        console.log(data);
        if (data && data.deviceid) {
          resolve(data.deviceid.toString());
        } else {
          resolve('');
        }
      })
    } else if (isManApp()) {
      let app_deviceid = getCookie('app_deviceid') || '';
      if (app_deviceid) {
        resolve(app_deviceid);
      } else {
        AHAPP.invokeNative("getdeviceinfo", {
          success: function (data) {
            console.log(data);
            if (data && data.returncode === 0 && data.result.deviceid) {
              resolve(data.result.deviceid);
            } else {
              //如果app再取不到就再取一下cookie
              let app_deviceid = getCookie('app_deviceid') || '';
              resolve(app_deviceid);
            }
          },
          fail: function (result) {
            //如果app再取不到就再取一下cookie
            let app_deviceid = getCookie('app_deviceid') || '';
            resolve(app_deviceid);
          }
        });
      }
    } else {
      let uid = $.getCookie('sessionid', '');
      resolve(uid);
    }
  });
}
Date.prototype.Format = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份 
    "d+": this.getDate(), //日 
    "h+": this.getHours(), //小时 
    "m+": this.getMinutes(), //分 
    "s+": this.getSeconds(), //秒 
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度 
    "S": this.getMilliseconds() //毫秒 
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}

//取cookie方法,原$.getCookie() 有缺陷
function getCookie(name) {
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg)) { return decodeURIComponent(arr[2]) }
  else { return '' };
}
//设置cookie
function setCookie(name, value, expiredays) {
  let exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie = `${name}=${encodeURI(value)}`;
  document.cookie += expiredays ? `;expires=${exdate.toGMTString()}` : ``;
}
//删除cookie
function delCookie(name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null)
    document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
}
//设置cookie： setCookie("name","hayden","s20");
//s20是代表20秒
//h是指小时，如12小时则是：h12
//d是天数，30天则：d30
function setCookieTime(name, value, time) {
  var strsec = getsec(time);
  var exp = new Date();
  exp.setTime(exp.getTime() + strsec * 1);
  document.cookie = name + "=" + encodeURIComponent(value) + ";expires=" + exp.toGMTString();
}
function getsec(str) {
  var str1 = str.substring(1, str.length) * 1;
  var str2 = str.substring(0, 1);
  if (str2 == "s") {
    return str1 * 1000;
  }
  else if (str2 == "h") {
    return str1 * 60 * 60 * 1000;
  }
  else if (str2 == "d") {
    return str1 * 24 * 60 * 60 * 1000;
  }
}
//加密手机号
function mobileEncry(str) {
  let newStr = "";
  if (str.length < 3) {
    newStr = str;
  } else if (str.length >= 3 && str.length <= 7) {
    newStr =
      str.substr(0, 3) +
      repeatStringNumTimes("*", str.length - 3);
  } else if (str.length > 7) {
    newStr =
      str.substr(0, 3) +
      repeatStringNumTimes("*", 4) +
      str.substr(7, str.length);
  }
  return newStr;
}
/* 对手机号进行加密 */
function XxxEncode(code) {
  var c = ""; var xxxAarr = ['u', 'x', 'k', 'd', 'o', 'p', 'g', 's', 'v', 'j'];
  for (var i = 0; i < code.length; i++) {
    c += xxxAarr[code[i]];

    if ((i + 1) % 2 === 0) {
      c += "-";
    }
  }
  return c;
}

//判断当前app版本号是否大于某个版本号返回 bool @baseVerNum 基版本号，@curVerNum 当前版本号
function checkVerNum(baseVerNum, curVerNum) {
  let a = baseVerNum.replace('.', '');
  let b = curVerNum.replace('-debug', '').replace('.', '');
  return b >= a;
}

//打开webview Scheme url(只兼容主软和二手车app)
function openSchemeUrl(url) {
  let jumpUrl = url;
  if (jumpUrl.startsWith("//")) {
    jumpUrl = "https:" + jumpUrl;
  }
  if (isEscApp()) {
    jumpUrl = `${SCHEME.USEDCAR}/web?param=${encodeURIComponent(`{"url":"${jumpUrl}"}`)}`;
  } else if (isManApp() && typeof openChangeAroundUrl === 'function') {
    openChangeAroundUrl(url);
    return;
  }
  // console.log(url, jumpUrl);
  location.href = jumpUrl;
}
/* 验证验证码 */
function checkMobileCode(mobileCode) {
  return (
    mobileCode &&
    mobileCode.toString().length === 6 &&
    /[0-9]{6}/.test(mobileCode)
  );
}
export {
  checkVerNum,
  getPriceRegion, getUniqueid, getBrowser, getAPPID, domAppendJs, isEscApp, isATCApp, isManApp, isWechat, openListUlr, cid2pid, getUrlParams, checkMobile, transformToUrl, uniqueArr, getPnameFromPid, getCnameFromCid, timeDiff, getGeolocation, getCookie,
  setCookie, delCookie, setCookieTime, mobileEncry, XxxEncode,openSchemeUrl,checkMobileCode
}




// WEBPACK FOOTER //
// ./src/util/util.js